<template>
  <div class="re-exam">
    <div class="text-center">
      <h1 class="dastnevis py-5">درک مطلب خود را از داستان بسنجیم</h1>
      <div class="re-exam-box py-5 mx-auto">
        <v-card class="my-5">
          <v-progress-linear
            height="15"
            color="green"
            :value="((tab + 1) * 100) / 12"
          />
          <v-tabs
            v-model="tab"
            :change="addAnswers(selected)"
            hide-slider
            background-color="grey lighten-3"
            fixed-tabs
          >
            <v-tab
              class="font-weight-bold text-body-1"
              active-class="green lighten-1 white--text"
              v-for="(item, index) in questions"
              :key="item._id"
              :index="index"
            >
              سوال {{ index + 1 }}
            </v-tab>

            <v-tab-item v-for="question in questions" :key="question._id" eager>
              <v-card flat>
                <v-card-text class="black--text">
                  <div v-if="question.type === 'text'">
                    <div class="re-question my-8 text-h4 font-weight-bold">
                      {{ question.text }}
                    </div>
                    <v-chip v-if="userTypeAccess">
                      سطح درک مطلب:
                      <strong class="mr-1">{{ question.subject }}</strong>
                    </v-chip>
                  </div>
                  <div v-else>
                    <div
                      v-if="question.text"
                      class="re-question my-8 text-h4 font-weight-bold"
                    >
                      {{ question.text }}
                    </div>
                    <v-img
                      max-width="600px"
                      class="mx-auto"
                      :src="
                        'https://dl.pirls.ir/app/exams/' + question._id + '.jpg'
                      "
                    />
                  </div>
                  <QuestionAnswers
                    :question-id="question._id"
                    @child-to-parent="onSelected"
                  />
                </v-card-text>
                <v-card-actions class="grey lighten-3 d-flex align-center pa-3">
                  <div v-if="tab != 0">
                    <v-btn
                      class="mx-0 font-weight-bold"
                      color="error"
                      depressed
                      @click="previosTab() || scrollToTop()"
                    >
                      قبلی
                    </v-btn>
                  </div>
                  <v-spacer />
                  <div v-if="tab != 11">
                    <v-btn
                      class="mx-0 font-weight-bold"
                      color="primary"
                      depressed
                      @click="nextTab() || scrollToTop()"
                    >
                      بعدی
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-btn
                      class="px-16"
                      :loading="loading"
                      :disabled="loading"
                      depressed
                      color="success"
                      @click="submitExam()"
                    >
                      ارســـال آزمون
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </div>
    </div>

    <MenuComponent :book-id="this.$route.params.id" state="exam" />
  </div>
</template>

<script>
import MenuComponent from "./Menu.vue";
import QuestionAnswers from "./Exam/QuestionAnswers.vue";
export default {
  name: "exam-component",
  components: { MenuComponent, QuestionAnswers },
  data() {
    return {
      loading: false,
      tab: null,
      questions: null,
      selected: "",
      selectedlist: [],
      answerSheet: []
      // keys: [],
    };
  },
  computed: {
    userTypeAccess() {
      const user = this.$store.getters.user.type;
      if (user === "ادمین" || user === "اپراتور") {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getQuestion();
  },
  methods: {
    getQuestion() {
      this.$api.get("/questions/" + this.$route.params.id).then((res) => {
        this.questions = res.data.questions;
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    nextTab() {
      if (this.tab === 11) {
        this.tab = 11;
      } else {
        this.tab += 1;
      }
    },
    previosTab() {
      if (this.tab === 0) {
        this.tab = 0;
      } else {
        this.tab -= 1;
      }
    },
    addAnswers(id) {
      if (id) {
        this.$api.get("/answer/" + id).then((res) => {
          const questionId = res.data.answer.bookQuestion;
          const checkAnswers = this.selectedlist.findIndex(
            (a) => a.bookQuestion === questionId
          );
          if (checkAnswers != -1) {
            this.selectedlist.splice(checkAnswers, 1);
          }
          this.selectedlist.push(res.data.answer);
          this.selected = "";
        });
      }
    },
    onSelected(value) {
      this.selected = value;
    },
    submitExam() {
      this.loading = true;
      this.$api
        .post("/answerSheet/add", {
          user: this.$store.getters.user._id,
          book: this.$route.params.id
        })
        .then((res) => {
          const answerSheetId = res.data.answerSheet._id;
          this.selectedlist.forEach((e) => {
            this.answerSheet.push({
              answerSheet: answerSheetId,
              question: e.bookQuestion,
              answer: e._id
            });
          });

          this.$api
            .post("/answerSheetItem/addMany", this.answerSheet)
            .then(() => {
              this.$api.patch("/answerSheet/update/", {
                answerSheet: answerSheetId
              });
            });

          this.$router.push({
            name: "Report",
            params: { id: this.$route.params.id }
          });
        });
    }
  }
};
</script>

<style>
.v-card__title {
  word-break: normal;
}
.re-question {
  line-height: 45px;
}
.v-slide-group__prev--disabled {
  display: none !important;
}
</style>
